import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';
import { NotificationsService } from '../services/notifications.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  public notificationCount: Number = 0;
  public notifications: any = [];
  public allNotifications: any = null;
  public unreadNotifications: any = null;
  public notificationType: String = 'unread';

  constructor(private AuthenticationService: AuthenticationService, private NotificationsService: NotificationsService) { }

  ngOnInit() {
    this.getAllUserNotifications(this.AuthenticationService.id());
  }

  getAllUserNotifications (userId) {
    this.NotificationsService.getAllUserNotifications(userId).subscribe(
      (data: any) => {
        this.allNotifications = data.notifications;
        this.unreadNotifications = data.notifications.filter((notification) => {
          return notification.acknowledged.isAcknowledged == false;
        });
        this.notificationCount = this.unreadNotifications.length;
        this.notifications = (this.notificationType == 'all') ? this.allNotifications : this.unreadNotifications;
      },
      err => console.error(err)
    );
  }

  acknowledgeNotification(id) {
    this.NotificationsService.acknowledgeNotification(id).subscribe(
      (data) => { 
        if(this.notificationType == 'unread'){
          this.getAllUserNotifications(this.AuthenticationService.id());
        } else if(this.notificationType == 'all'){
          this.getAllUserNotifications(this.AuthenticationService.id());
        }
      }
    );
  }

  setFilter(type) {
    if(type == 'unread'){
      this.notificationType = 'unread';
      this.notifications = this.unreadNotifications;
    } else if(type == 'all') {
      this.notificationType = 'all';
      this.notifications = this.allNotifications;
    }
  }
}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/notification/notification.component.ts